import React from "react";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import { KnockoutStage } from "../types/TournamentMatch";
import { getStagePoints } from "../utils/stagePoints";
import "./StagePointsChip.scss";

interface StagePointsChipProps {
  stage: KnockoutStage;
  /** Extra class for layout tweaks at the call site. */
  className?: string;
}

/**
 * Compact chip showing the reward for the round: check icon = right outcome,
 * bolt icon = perfect score. Values come from the shared stagePoints map (which
 * mirrors the backend TyperScore), so they can't drift from the real scoring.
 */
const StagePointsChip: React.FC<StagePointsChipProps> = ({
  stage,
  className,
}) => {
  const { outcome, exact } = getStagePoints(stage);
  return (
    <span
      className={`stagePointsChip${className ? ` ${className}` : ""}`}
      title={`Points this round — right outcome +${outcome}, perfect score +${exact}`}
    >
      <CheckCircleOutlineRoundedIcon className="stagePointsChip__icon" />
      <span className="stagePointsChip__val">+{outcome}</span>
      <BoltRoundedIcon className="stagePointsChip__icon stagePointsChip__icon--accent" />
      <span className="stagePointsChip__val stagePointsChip__val--accent">
        +{exact}
      </span>
      <span className="stagePointsChip__unit">points</span>
    </span>
  );
};

export default StagePointsChip;
